import {PlantHierarchyNode, getUpmHierarchySummary} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import {api} from '../App.store'

type UseUpmHierarchySummaryParams = {
  hierarchyIds: string[]
  enabled?: boolean
}

export const useUpmHierarchySummary = ({
  hierarchyIds,
  enabled = true
}: UseUpmHierarchySummaryParams) => {
  const filteredHierarchyIds = hierarchyIds.filter(Boolean)
  const sortedHierarchyIds = [...filteredHierarchyIds].sort()

  return useQuery(
    ['upmHierarchySummary', sortedHierarchyIds],
    async (): Promise<PlantHierarchyNode[]> => {
      return getUpmHierarchySummary(api)(sortedHierarchyIds)
    },
    {
      enabled: enabled && sortedHierarchyIds.length > 0,
      retry: false
    }
  )
}
